import React from 'react';
//internal or external components and containers
import { Box, Typography, Avatar } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { colors } from '../../common/pallette/colors';
import { useTranslation } from 'react-i18next';
import { report } from 'process';
import { commonStatus, finalReportStatus, interimReportStatus, liecenceAdmin, liecenceHome, phaseStatus, rabgStatus, siteReviewStatus } from '../../common/StaticExports';

const displayStatus = (key: String, status: number) => {
    switch (key) {
        case 'interim':
            return interimReportStatus[status];

        case 'final':
            return finalReportStatus[status];
            
        case 'rabg':
            return rabgStatus[status];
        
        case 'siteReview':
            return siteReviewStatus[status];

        case 'liecenceHome':
            return liecenceHome[status];
            
        case 'liecenceAdminAction':
            return liecenceAdmin[status];
        
        case 'clubPhases':
            return phaseStatus[status];
    
        default:
            return commonStatus[status];
    }
}

const StatusIndicatorCircleSmall = (props: any) => {
    const { reportType, status, mr, ml, noMtb } = props;
    const s: number = +status;
    return(
        <React.Fragment>
            <Box className={noMtb ? '' : 'mtbAuto'}>
                <Avatar sx={{
                    width: 10,
                    height: 10,
                    mr: mr ? mr : 0,
                    mt: 'auto',
                    mb: 'auto',
                    ml: ml ? ml : 0,
                    bgcolor: displayStatus(reportType, s)?.color,
                    border: displayStatus(reportType, s)?.color == '#FFF' ?
                    '1px solid black' : 
                    `1px solid ${displayStatus(reportType, s)?.color}`}}>
                        {' '}
                </Avatar>
            </Box>
        </React.Fragment>
    )
}

export default StatusIndicatorCircleSmall;